var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 17.5,
    fill: "url(#paint0_linear_219_164)",
    fillOpacity: 0.3,
    stroke: "#4B4C60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3945 40L37.691 37.7031C38.9533 36.4406 39.9938 35.4062 40.0032 35.4062C40.0126 35.4062 41.053 36.4406 44.6118 40L40.0032 44.6094L35.3945 40Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7178 32.2813C27.7115 32.2531 30.3517 29.5938 33.8324 26.1188C37.2007 22.7531 39.9784 20 40.0034 20C40.0284 20 42.8029 22.7531 46.168 26.1188C49.53 29.4813 52.2827 32.2563 52.2827 32.2813C52.2827 32.3063 51.2735 33.3375 50.0424 34.5688C48.8082 35.8031 47.7834 36.8125 47.7678 36.8125C47.7521 36.8125 45.9962 35.0719 40.0034 29.0781L36.1352 32.9438C34.0105 35.0719 32.2546 36.8125 32.2389 36.8125C32.2202 36.8125 31.1985 35.8031 29.9643 34.5688C28.7332 33.3375 27.7209 32.3063 27.7178 32.2813Z",
    fill: "#B5B5B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C19.9938 39.975 20.9749 38.975 22.2403 37.7125C23.4776 36.4781 24.5024 35.4688 24.5212 35.4688C24.5368 35.4688 25.5617 36.4781 26.7958 37.7125C28.0269 38.9438 29.0361 39.975 29.0361 40C29.0361 40.025 28.0269 41.0563 26.7958 42.2875C25.5617 43.5219 24.5399 44.5313 24.5212 44.5313C24.5024 44.5313 23.4807 43.5219 22.2466 42.2875C21.0155 41.0563 20.0032 40.025 20 40Z",
    fill: "#B5B5B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9639 40C50.9576 39.975 51.9387 38.975 53.2042 37.7125C54.4415 36.4781 55.4663 35.4688 55.4851 35.4688C55.5007 35.4688 56.5255 36.4781 57.7597 37.7125C58.9908 38.9438 60 39.975 60 40C60 40.025 58.9908 41.0563 57.7597 42.2875C56.5255 43.5219 55.5007 44.5313 55.4851 44.5313C55.4694 44.5313 54.4446 43.5219 53.2104 42.2875C51.9794 41.0563 50.967 40.025 50.9639 40Z",
    fill: "#B5B5B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6768 47.7188L29.942 45.4531C31.1887 44.2063 32.2198 43.1875 32.2385 43.1875C32.2542 43.1875 34.0101 44.9281 40.0029 50.9219L43.8711 47.0563C45.9958 44.9281 47.7517 43.1875 47.7674 43.1875C47.7861 43.1875 48.8172 44.2063 52.3291 47.7188L46.1895 53.8594C42.8119 57.2375 40.0279 60 40.0029 60C39.978 60 37.194 57.2375 27.6768 47.7188Z",
    fill: "#B5B5B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_164",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.609f8cb6622dd692bf68198f754e9c3d.svg";
export { ForwardRef as ReactComponent };